// API
import * as CalendarMeetingsAPI from '../api/CalendarMeetings.api';

// Constants
import CalendarMeetingsConstants from 'Shared/constants/CalendarMeetings.constants';

// Utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// Schemas
import CalendarMeetingSchema from 'Shared/utils/normalizeJSON/schemas/CalendarMeeting.schema';

export const fetchCalendarMeetingsSuccess = payload => ({
  type: CalendarMeetingsConstants.Actions.FETCH_CALENDAR_MEETINGS_SUCCESS,
  payload,
});

export const fetchCalendarMeetings =
  ({ day, forceResync = false }: { day: string; forceResync?: boolean }) =>
  dispatch => {
    return CalendarMeetingsAPI.fetchCalendarMeetings({ forceResync }).then(response => {
      const payload = {
        day,
        response: normalizer(CalendarMeetingSchema, response.data),
      };
      dispatch(fetchCalendarMeetingsSuccess(payload));
      return response;
    });
  };
